import { convertMinutesToMilliSeconds } from './utils';

export enum AuthStorageKeys {
  authConfig = 'authConfig',
  accountId = 'accountId',
  accessTokenByAccountId = 'accessTokenByAccountId',
  sessionByAccountId = 'sessionByAccountId',
}

const defaultIdleTimeout = -1; // no idle timeout was set, do not logout the user
export const getTimeoutFromAuthConfig = ({ key, defaultValue }: { key: string; defaultValue: number }) => {
  const authConfig = JSON.parse(localStorage.getItem(AuthStorageKeys.authConfig) || 'null');
  const timeoutValue = authConfig?.[key];
  // if there is timeout value of -1, it means the timeout is disabled when key is logoutInactivityTimeout
  if (timeoutValue === defaultIdleTimeout) {
    return defaultIdleTimeout;
  }

  return timeoutValue ? convertMinutesToMilliSeconds(timeoutValue) : convertMinutesToMilliSeconds(defaultValue);
};

export const getAccessTokenTimeout = () => {
  const timeoutInSeconds = getTimeoutFromAuthConfig({ key: 'accessTokenTimeoutInMinutes', defaultValue: 5 }); // default is 5 minutes
  return timeoutInSeconds - 30000; // remove half minute to prevent race condition
};

export const setAccountTokenInLs = ({ token, accountId }) => {
  if (accountId) {
    const accessTokenByAccountIdValue = JSON.parse(localStorage.getItem(AuthStorageKeys.accessTokenByAccountId) || '{}');
    localStorage.setItem(AuthStorageKeys.accessTokenByAccountId, JSON.stringify({ ...accessTokenByAccountIdValue, [accountId]: token }));
  }
};

export const getAccountSessionFromLs = accountId => JSON.parse(localStorage.getItem(AuthStorageKeys.sessionByAccountId) || '{}')[accountId];

export const setAccountSessionInLs = ({ session, accountId }) => {
  if (session) {
    const sessionByAccountIdValue = JSON.parse(localStorage.getItem(AuthStorageKeys.sessionByAccountId) || '{}');
    localStorage.setItem(AuthStorageKeys.sessionByAccountId, JSON.stringify({ ...sessionByAccountIdValue, [accountId]: session }));
  }
};

export const getAllLSKeys = () => {
  const { length } = localStorage;
  const keys: string[] = [];
  const keysToExclude = ['ZD-store', 'ZD-suid', 'layoutWidths', 'ZD-buid'];
  // eslint-disable-next-line fabric-ui/no-let
  for (let i = 0; i < length; i++) {
    const key = localStorage.key(i);
    if (key && !keysToExclude.includes(key)) {
      keys.push(key);
    }
  }

  return keys;
};
